import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLayoutComponent } from './core/app-layout/app-layout.component';
import { TestUserComponent } from './features/test-user/test-user.component';
import { SigninCallbackComponent } from './features/signin-callback/signin-callback.component';
import { SignoutCallbackComponent } from './features/signout-callback/signout-callback/signout-callback.component';
import { ConfirmedemailCallbackComponent } from './features/confirmedemail-callback/confirmedemail-callback.component';
import { HomeComponent } from './features/home/home.component';
import { AuthCanLoadGuard } from './core/services/guards/Authentication/auth.can-load.guard';
import { ChangeemailCallbackComponent } from './features/changeemail-callback/changeemail-callback.component';
import {RevokedSessionComponent} from './features/revocked-session/revoked-session.component';
import {RevokedSessionCanActivateGuard} from './core/services/guards/revoked-session/revoked-session.can-activate-guard.service';
import {UserConsentsCanActivateGuard} from './core/services/guards/user-consents/user-consents-can-activate-guard.service';
import {GuestCanActivateGuard} from './core/services/guards/guest-can-activate-guard.service';

const routes: Routes = [
  {
    path: 'signin-callback',
    component: SigninCallbackComponent,
  },
  {
    path: 'signout-callback',
    component: SignoutCallbackComponent,
  },
  {
    path: 'confirmedemail-callback',
    component: ConfirmedemailCallbackComponent,
  },
  {
    path: 'changepassword-callback',
    component: ConfirmedemailCallbackComponent,
  },
  {
    path: 'changeemail-callback',
    component: ChangeemailCallbackComponent,
  },
  {
    path: 'test-user',
    component: TestUserComponent
  },
  {
    path: 'change-password-request',
    loadChildren: () => import('./features/change-password-request/change-password-request.module').then(m => m.ChangePasswordRequestModule),
  },
  {
    path: 'change-password-operation',
    loadChildren: () => import('./features/change-password/change-password.module').then(m => m.ChangePasswordModule),
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: 'home',
        // component: CourtesyhomeComponent
        component: HomeComponent,
        canActivate: [GuestCanActivateGuard]
      },
      {
        path: 'registration',
        loadChildren: () => import('./features/registration/registration.module').then(m => m.RegistrationModule),
      },
      {
        path: 'menu',
        loadChildren: () => import('./features/features-user.module').then(m => m.FeaturesUserModule),
        canLoad: [AuthCanLoadGuard],
        canActivate: [UserConsentsCanActivateGuard],
      },
      {
        path: 'public-news',
        loadChildren: () => import('./features/news-article-public/news-article-public.module').then(m => m.NewsArticlePublicModule),
      },
      { path: 'revoked-session', component: RevokedSessionComponent, canActivate: [RevokedSessionCanActivateGuard] },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'home' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}


